// eslint-disable-next-line no-shadow
export enum TAlertStatus {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  DEFAULT = 'default',
}

// eslint-disable-next-line no-shadow
export enum TAlertType {
  GENERAL = 'general',
  TOP = 'top',
  MIDDLE = 'middle',
  BOTTOM = 'bottom',
  IC_PAYMENT_UPDATE = 'ic_payment_update',
  IC_ADDRESS_UPDATE = 'ic_address_update',
}

export interface IAlertMessage {
  alertStatus: TAlertStatus;
  alertType?: TAlertType;
  text: React.ReactChild;
}
